module.exports = __webpack_public_path__ + "static/media/backbone_logo_white.18bf4558.png";